export default __webpack_public_path__ + "static/media/Int_PREVIRED.a1f8400a.svg";